module.exports = __webpack_public_path__ + "static/media/pagination-previous-disabled.7e6e0f46.svg";